module.exports = __webpack_public_path__ + "static/media/logo-dark.b7175bbb.png";